"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var Modal_1 = __importDefault(require("react-overlays/lib/Modal"));

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var withResponsive_1 = require("../decorators/withResponsive");

var withStyles_1 = require("../decorators/withStyles");

var Popup_styles_1 = require("./Popup.styles");

var Popup =
/** @class */
function (_super) {
  __extends(Popup, _super);

  function Popup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Popup.prototype.render = function () {
    var _a;

    var _b = this.props,
        show = _b.show,
        container = _b.container,
        onHide = _b.onHide,
        backdrop = _b.backdrop,
        onEscapeKeyUp = _b.onEscapeKeyUp,
        onBackdropClick = _b.onBackdropClick,
        closeByEsc = _b.closeByEsc,
        autoFocus = _b.autoFocus,
        enforceFocus = _b.enforceFocus,
        restoreFocus = _b.restoreFocus,
        manager = _b.manager,
        children = _b.children,
        classes = _b.classes,
        width = _b.width,
        height = _b.height,
        closeByBackdropClick = _b.closeByBackdropClick,
        onShow = _b.onShow,
        overflowVisible = _b.overflowVisible,
        portalHeaderMode = _b.portalHeaderMode,
        testId = _b.testId;
    var inlineStyles = {};

    if (width) {
      inlineStyles.width = width;
    }

    if (height) {
      inlineStyles.height = height;
    }

    var back = backdrop !== false;

    if (back && !closeByBackdropClick) {
      back = 'static';
    }

    var overflowClasses = {};

    switch (overflowVisible) {
      case 'desktop':
        overflowClasses[classes.overflowVisibleDesktop] = true;
        break;

      case 'mobile':
        overflowClasses[classes.overflowVisibleMobile] = true;
        break;

      case true:
        overflowClasses[classes.overflowVisible] = true;
        break;
    }

    return react_1.default.createElement(Modal_1.default, {
      show: show,
      container: container,
      containerClassName: classes.container,
      className: classes.flexContainer,
      onShow: onShow,
      onHide: onHide,
      backdrop: back,
      onEscapeKeyUp: onEscapeKeyUp,
      onBackdropClick: onBackdropClick,
      backdropClassName: classes.background,
      keyboard: closeByEsc,
      autoFocus: autoFocus,
      enforceFocus: enforceFocus || false,
      restoreFocus: restoreFocus,
      manager: manager
    }, react_1.default.createElement("div", {
      "data-test-id": testId || 'popup-wrapper',
      className: classnames_1.default(classes.wrapper, mobileStylesHelper_1.createMobileClasses(this.props), overflowClasses, (_a = {}, _a[classes.portalHeaderMode] = portalHeaderMode, _a)),
      style: inlineStyles
    }, children));
  };

  Popup = __decorate([withResponsive_1.withResponsive, withStyles_1.withStyles(Popup_styles_1.styles)], Popup);
  return Popup;
}(react_1.default.PureComponent);

exports.default = Popup;